import { GlobalResponseObject, UnitRequest } from '@gtpl/shared-models/common-models';
import axios from 'axios';
import connection from './connection';
import { AllGrnResponseModel, GrnDetailViewResponseModel, GrnDto, GrnIdRequest, GrnQtyRequest, GrnQtyResponseModel, grnResponse, PoDropDownDto, PoDropDownResponseModel, PoItemsResponseModel, PoRequest, GrnReturnAutoFillDto, GrnReturnAutoFillModel, GrnNumberResponseModel, GrnNumberDto, GrnItemReceivedQtyRequest, GrnItemReceivedQtyResponse, GrnItemReturnResponseModel, GrnReturnItemSaveDto, GrnReturnItemsDto, AllGrnReportResponse, GrnRtRequest, GrnItemReturnResponse, GrnAbstractResponse, GrnInspectionreq, grnReportreq, grnIdreq, GrnItemIdRequest, QuantityDeviationRequest, BatchNumRequest, LotNumRequest, RmCountRequest, RmReceivingReportReq, GrnIDRequest, RmRatesReportReq, getMonthWisePurchaseRequest } from "@gtpl/shared-models/procurement-management";
// import { PoDropDownDto, PoDropDownResponseModel } from "@gtpl/shared-models/procurement-management";
import { GrnReturnDto, GrnReturnResponseModel } from "@gtpl/shared-models/procurement-management";
import {grnAbstract, PayablesDashboardReq} from '@gtpl/shared-models/raw-material-procurement';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { CommonResponse as Response } from '@gtpl/shared-models/sale-management';
import { FileUploadResponse } from 'libs/shared-models/logistics/src/lib/container-log-book/file-upload.response';
import { IdRequest } from '@gtpl/shared-models/gtpl';

export class GrnService {
    URL = connection.DEPLOY_URL + '/grn';


    async createGrn(grnDto: GrnDto): Promise<grnResponse> {
        // console.log(selectedCustomer, selectedClient,selectedSaleOrder,selectedStatus, selectedExpectedDate);
        return await axios.post(this.URL + '/createGrn', grnDto)
            .then(res => {
                return res.data
            })
    }




    async getPoDataById(poIdReq: PoRequest): Promise<PoItemsResponseModel> {

        return await axios.post(this.URL + '/getPoDataById', poIdReq)
            .then(res => {
                return res.data
            })
    }

    async getGrnQtyByPoId(poIdReq: GrnQtyRequest): Promise<GrnQtyResponseModel> {

        return await axios.post(this.URL + '/getGrnQtyByPoId', poIdReq)
            .then(res => {
                return res.data
            })
    }

    async getGrnByPoId(poIdReq: GrnQtyRequest): Promise<CommonResponse> {

        return await axios.post(this.URL + '/getGrnByPoId', poIdReq)
            .then(res => {
                return res.data
            })
    }

    async getAllGrnDetails(req?: UnitRequest): Promise<AllGrnResponseModel> {

        return await axios.post(this.URL + '/getAllGrnDetails',req)
            .then(res => {
                return res.data
            })
    }

    async getAllGrnData(req?: UnitRequest): Promise<AllGrnResponseModel> {

        return await axios.post(this.URL + '/getAllGrnData',req)
            .then(res => {
                return res.data
            })
    }
    async getAllGrnReport(req?: GrnRtRequest): Promise<AllGrnReportResponse> {

        return await axios.post(this.URL + '/getAllGrnReport', req)
            .then(res => {
                return res.data
            })
    }
    async getSoDropForGrnReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSoDropForGrnReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getPoDropForGrnReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPoDropForGrnReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getItemSubDropForGrnReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getItemSubDropForGrnReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getItemDropForGrnReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getItemDropForGrnReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getVendorDropForGrnReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorDropForGrnReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }


    async getAllActiveGrnNumbers(req?:UnitRequest): Promise<GrnNumberResponseModel> {
        return await axios.post(this.URL + '/getAllActiveGrnNumbers',req)
            .then(res => {
                return res.data
            })
    }

    async getGrnReturnAutoFillDataByGrnNumber(grnIdReq: GrnIdRequest): Promise<GrnReturnAutoFillModel> {
        return await axios.post(this.URL + '/getGrnReturnAutoFillDataByGrnNumber', grnIdReq)
          .then(res => {
            return res.data
          })
    }





    async getGrnDataById(grnIdReq: GrnIdRequest): Promise<GrnDetailViewResponseModel> {

        return await axios.post(this.URL + '/getGrnDataById', grnIdReq)
            .then(res => {
                return res.data
            })
    }

    async getGrnItemReceivedQtyByGrnIdandItem(grnItemReq: GrnItemReceivedQtyRequest): Promise<GrnItemReceivedQtyResponse> {
        return await axios.post(this.URL + '/getGrnItemReceivedQtyByGrnIdandItem', grnItemReq)
            .then(res => {
                return res.data
            });
        return new GrnItemReceivedQtyResponse(true, 11, '', 4)
    }

    async getAllGrnReturnItemsForGrid(): Promise<GrnReturnResponseModel> {
        return await axios.post(this.URL + '/getAllGrnReturnItemsForGrid')
            .then(res => {
                return res.data;
            })
    }

    async getGrnReturnItemsById(grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponseModel> {
        return await axios.post(this.URL + '/getGrnReturnItemsById')
            .then(res => {
                return res.data;
            })
    }

    async getGrnDataByIdForReturn(grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponse> {
        return await axios.post(this.URL + '/getGrnDataByIdForReturn', grnIdReq)
            .then(res => {
                return res.data;
            })
    }
    async getGRNAbstract(req :grnAbstract) : Promise<GrnAbstractResponse>{
        return await axios.post(this.URL + '/getGRNAbstract', req)
        .then(res=>{
        return res.data
        })
    }
    async getTransferredSosDataForGrnGrid(req?:UnitRequest) : Promise<GrnAbstractResponse>{
        return await axios.post(this.URL + '/getTransferredSosDataForGrnGrid', req)
        .then(res=>{
        return res.data
        })
    }
    

    async grninfoforpending(req?: UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/grninfoforpending',req)
        .then(res=>{
        return res.data
        })
    }
    async saveGrnInspection(req?: grnIdreq) : Promise<CommonResponse>{
        console.log(req,"sharedserbiceeeeeeeeeeeeee");
        
        return await axios.post(this.URL + '/saveGrnInspection',req)
        .then(res=>{
        return res.data
        })
    } 
    async getGrnitemById(req?: GrnInspectionreq) : Promise<CommonResponse>{
        
        return await axios.post(this.URL + '/getGrnitemById',req)
        .then(res=>{
        return res.data
        })
    } 
    async getGrnReportData(req?: grnReportreq) : Promise<CommonResponse>{
        
        return await axios.post(this.URL + '/getGrnReportData',req)
        .then(res=>{
        return res.data
        })
    } 
    async getGrnReportPoNum(req?: grnReportreq) : Promise<CommonResponse>{
        
        return await axios.post(this.URL + '/getGrnReportPoNum',req)
        .then(res=>{
        return res.data
        })
    } 
    async getGrnReportExcel() : Promise<CommonResponse>{
        
        return await axios.post(this.URL + '/getGrnReportExcel')
        .then(res=>{
        return res.data
        })
    }

    async getInspectedGRNNumbersDropdown() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInspectedGRNNumbersDropdown')
        .then(res=>{
        return res.data
        })
    }

    async getInspectedGrnInfo(req:GrnIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInspectedGrnInfo',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmWeighment(req:GrnItemIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmWeighment',req)
        .then(res=>{
        return res.data
        })
    }
    async getQuantityDeviation(req:QuantityDeviationRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getQuantityDeviation',req)
        .then(res=>{
        return res.data
        })
    }
    async getQuantityDeviationIndents() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getQuantityDeviationIndents')
        .then(res=>{
        return res.data
        })
    }
    async getQuantityDeviationFarmers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getQuantityDeviationFarmers')
        .then(res=>{
        return res.data
        })
    }
    async getQuantityDeviationBatches() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getQuantityDeviationBatches')
        .then(res=>{
        return res.data
        })
    }
    async getPuchareAnalysisReport(req:BatchNumRequest) : Promise<Response>{
        return await axios.post(this.URL + '/getPuchareAnalysisReport',req)
        .then(res=>{
        return res.data
        })
    }
    async getPuchareAnalysisData(req:BatchNumRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPuchareAnalysisData',req)
        .then(res=>{
        return res.data
        })
    }
    async getAllBatchesForReWeighment(req:IdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllBatchesForReWeighment',req)
        .then(res=>{
        return res.data
        })
    }
    async getAllBatchesForLive(req:IdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllBatchesForLive',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmPriceByCount(req:RmCountRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmPriceByCount',req)
        .then(res=>{
        return res.data
        })
    }
    async getLivePurchase(req:BatchNumRequest) : Promise<Response>{
        return await axios.post(this.URL + '/getLivePurchase',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRecievingReportData(req:RmReceivingReportReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmRecievingReportData',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRecievingReportSummary(req:RmReceivingReportReq) : Promise<Response>{
        return await axios.post(this.URL + '/getRmRecievingReportSummary',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRates(req:any[]) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmRates',req)
        .then(res=>{
        return res.data
        })
    }
    async getGrnData(req?: any) : Promise<CommonResponse>{
        
        return await axios.post(this.URL + '/getGrnData',req)
        .then(res=>{
        return res.data
        })
    } 
    async grnFileUpload(file: any): Promise<FileUploadResponse> {
        console.log(file,'hhhhhhhhhhhhhhhhhhhhhhhhhh')
        return await axios.post(this.URL + '/grnFileUpload', file)
            .then(res => {
                return res.data
            })
      }
    
    async getInspectionDetails () : Promise<CommonResponse>{
 
         return await axios.post(this.URL + '/getInspectionDetails')
         .then(res =>{
            return res.data
         })
    }
    async  getStatusDetails ( req:GrnItemIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getStatusDetails',req)
        .then(res =>{
            return res.data
    })
}



    async getRawMaterialGrn(req: GrnIDRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRawMaterialGrn',req)
        .then(res=>{
        return res.data
        })
    }

    async getGrnPrint(req: GrnIDRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnPrint',req)
        .then(res=>{
        return res.data
        })
    }
    async getAllBatchesAgainstMainLot(req: BatchNumRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllBatchesAgainstMainLot',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRecievingReportOthersSummary(req:RmReceivingReportReq) : Promise<Response>{
        return await axios.post(this.URL + '/getRmRecievingReportOthersSummary',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRateReportData(req?:RmRatesReportReq) : Promise<Response>{
        return await axios.post(this.URL + '/getRmRateReportData',req)
        .then(res=>{
        return res.data
        })
    }
    async getRmRateReportCountRanges() : Promise<Response>{
        return await axios.post(this.URL + '/getRmRateReportCountRanges')
        .then(res=>{
        return res.data
        })
    }
    async getMonthWisePurchaseAnalysisReport(req:getMonthWisePurchaseRequest) : Promise<Response>{
        return await axios.post(this.URL + '/getMonthWisePurchaseAnalysisReport',req)
        .then(res=>{
        return res.data
        })
    }
    async getDeffectsPurchaseAnalysis(req:BatchNumRequest) : Promise<Response>{
        return await axios.post(this.URL + '/getDeffectsPurchaseAnalysis',req)
        .then(res=>{
        return res.data
        })
    }
    async getDeffectsLivePurchaseAnalysis(req:BatchNumRequest) : Promise<Response>{
        return await axios.post(this.URL + '/getDeffectsLivePurchaseAnalysis',req)
        .then(res=>{
        return res.data
        })
    }

    async getTotalPackingPayablesDashboard(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalPackingPayablesDashboard',req)
            .then(res => {
                return res.data
            })
    } 
    
    async getTotalPackingPaidsDashboard(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalPackingPaidsDashboard',req)
            .then(res => {
                return res.data
            })
    }   

        async getTotalPackingVendorPayables(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalPackingVendorPayables',req)
            .then(res => {
                return res.data
            })
    }

    async getTotalGeneralVendorPayables(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalGeneralVendorPayables',req)
            .then(res => {
                return res.data
            })
    }

        async getPayablesViewData(req?:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPayablesViewData',req)
            .then(res => {
                return res.data
            })
    }
    async getOverDuePackingRanges(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getOverDuePackingRanges',req)
            .then(res => {
                return res.data
            })
    } 

    async getOverDuePackinginvoices(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getOverDuePackinginvoices',req)
            .then(res => {
                return res.data
            })
    } 

    async getTotalPackingPaidsReport(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalPackingPaidsReport',req)
            .then(res => {
                return res.data
            })
    } 

    async getUnitsForCeoDashboard(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getUnitsForCeoDashboard')
            .then(res => {
                return res.data
            })
    } 
}


